import Vue from 'vue'
import App from './App.vue'
import Home from './views/home.vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

import router from './router/index.js'

//引入公共js文件
import util from "./utils/util.js"
Vue.prototype.util = util

import './utils/common.css'

import VueClipboard  from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.config.productionTip = false

new Vue({
	router: router,
	// render: h => h(Home)
	render: h => h(App),
}).$mount('#app')
